import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { Routes } from 'routes';

export const App = () => (
    <BrowserRouter>
        <ToastContainer
            position='top-right'
            theme='dark'
        />

        <Routes />
    </BrowserRouter>
);
